<template>
  <div id="dialog" @mousedown="stopDownDarg($event)" class="side_inner">
    <div id="funPanelArea" class="fk-funPanelArea" style="position: absolute;">
      <div class="fk-funPanelEntry">
        <div v-drags v-show="state.flag==true" style="cursor: move;" @click="downDarg($event)" class="entryBtnsList">
          <div class="funPanelEntryOverLay"></div>
          <div v-for="(i,index) in mItem" @click="onItem(index)" :class="['funPanelEntryBtn',i.mTname]">
            <div :class="['funPanelEntryBtnIcon',i.isyt]"></div>
            <span class="funPanelEntryBtnText">{{i.mText}}</span>
          </div>
        </div>
      </div>
      <div id="fk-funPanel" class="fk-funPanel" v-if="state.flag=='onItem0'">
        <div class="funOuterPanel" v-show="disDiv==0">
          <div v-drags style="cursor: move;" @mousedown="downDarg($event)" class="funMainNav">
            <div class="settingBtns">
              <div @click="allSettingBtns(4)" class="currentSetting currentSetting_module"></div>
              <div :class="['allSettingBtns',{'allSettingBtns_on':isAll}]">
                <div v-for="(i,iex) in mItem" @click="allSettingBtns(iex)" :class="['multiSwitchBtn', i.stylcss]"></div>
                <div @click="allSettingBtns(3)" :class="['multiSwitchBtn','multiSwitchBtn_module']"></div>
              </div>
            </div>
            <div :class="['curMainSetingNav',{tab_r_1:tabContent==1},{tab_r_2:tabContent==2},{tab_r_3:tabContent==3}]">
              <div @click="tabSetting(1)" class="mainSettingTab">基本模块</div>
              <div @click="tabSetting(2)" class="mainSettingTab">我的模块</div>
              <div @click="tabSetting(3)" class="mainSettingTab">自定义模块</div>
              <div class="triangleActive"></div>
            </div>
            <div class="closeFunPanel" @click="closeFunPane"><i class="closeFunPanelIcon"></i></div>
          </div>
          <div class="funSettingContent">
            <div v-if="tabContent==1" class="tab_1 panelInnerContent panelContentScroll panelSLevelContainer panelInnerContent_addModule mCustomScrollbar _mCS_10"
              funpaneldef="funPanelDef">
              <div id="mCSB_10" class="mCustomScrollBox mCS-fk-gray mCSB_vertical mCSB_outside">
                <div class="modular_add_tab">
                  <div :class="['modular_title',tabColumnContent==1?'modular_column_on':'']" @click="tabColumnSetting(1)">新增栏目</div>
                 <div :class="['modular_title',tabColumnContent==2?'modular_column_on':'']" @click="tabColumnSetting(2)">栏目模块</div>
                </div>

                <div id="mCSB_10_container" class="mCSB_container">
                  <div class="addModulePanelContent" v-if="tabColumnContent==1">
                    <div class="addModuleSeachTool">
                      <div class="searchAddModuleToolBtn"></div>
                    </div>
                    <div v-for="it in mItem[0].mtIteml" class="moduleFieldset" v-if="it.itemArr.length">
                      <div class="moduleLegend moduleLegend_on"><span class="mLegendText">{{it.tName}}</span></div>
                      <div class="moduleViewList moduleViewList_on">
                        <div v-for="it2 in it.itemArr" v-if="it2.isShow" draggable="true" @dragstart='drag($event,it2)'
                          :class="['moduleAloneArea', it2.aloneIcon]">
                          <div v-if="it2.isDel" @click="devYun(it.itemArr,it2)" class="cons_del">X</div>
                          <div class="moduleAloneIcon"></div>
                          <div class="moduleAloneText">{{it2.tText}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                 <div class="addModulePanelContent" v-if="tabColumnContent==2">
                    <div v-for="i in getDataCur.stream">
                      <div>
                        <span style="padding:10px 10px;color: #FF0097;display: block;">{{i.tText}}</span>
                        <div v-for="(item,index) in i.itemInner">
                          <div ref="sideChild" class="sideConChild"  >{{item.tText}}
                              <span class="icon edit_mode" @click="manageFuncur(item,index)"></span>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div v-if="tabContent==2" class="panelInnerContent panelContentScroll panelSLevelContainer panelInnerContent_addModule mCustomScrollbar _mCS_10 tab_2 my_item">
              <div class="mCustomScrollBox mCS-fk-gray mCSB_vertical mCSB_outside">
                <div class="mCSB_container">
                  <!--我的模块 -->
                  <div v-for="it in myModule" class="moduleFieldset" v-if="myModule.length&&it.items.length">
                    <div class="moduleLegend moduleLegend_on"><span class="mLegendText">{{it.name}}</span></div>
                    <div class="moduleViewList moduleViewList_on">
                      <div v-for="it2 in it.items" v-if="it.items.length" draggable="true" @dragstart='drag($event,it2.config)'
                        :class="['moduleAloneArea', it2.aloneIcon]">
                        <div @click="devYun(it.items,it2,'myMaterial')" class="cons_del">X</div>
                        <div class="moduleAloneIcon"></div>
                        <div class="moduleAloneText">{{it2.name}}</div>
                      </div>
                    </div>
                  </div>
                  <div v-if="!(myModule.length&&myModule[0].items.length)" class="no_data">暂无数据</div>
                </div>
              </div>
            </div>
            <div v-if="tabContent==3" class="panelInnerContent panelContentScroll panelSLevelContainer panelInnerContent_addModule mCustomScrollbar _mCS_10 tab_3 st_mc_th">
              <div class="mCustomScrollBox mCS-fk-gray mCSB_vertical mCSB_outside">
                <div class="mCSB_container">
                  <!-- 自定义模块  -->
                  <div class="moduleFieldset" v-if="customize.length">
                    <!--div class="moduleLegend moduleLegend_on"><span class="mLegendText">{{it.name}}</span></div-->
                    <div class="moduleViewList moduleViewList_on">
                      <div v-for="it2 in customize" draggable="true" @dragstart='drag($event,it2)' :class="['moduleAloneArea', it2.aloneIcon]">
                        <div @click="devYun(customize,it2,'customModule')" class="cons_del">X</div>
                        <div class="moduleAloneIcon"></div>
                        <div class="moduleAloneText">{{it2.name}}</div>
                      </div>
                    </div>
                  </div>
                  <div v-if="!customize.length" class="no_data">暂无数据</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fk-funPanel" v-if="state.flag=='onItem1'">
        <div class="funOuterPanel" v-show="disDiv==0">
          <div v-drags style="cursor: move;" @mousedown="downDarg($event)" class="funMainNav">
            <div class="settingBtns">
              <div @click="allSettingBtns(5)" class="curent_skin"></div>
              <div :class="['allSettingBtns',{'allSettingBtns_on':isAll}]">
                <div v-for="(i,idx) in mItem" @click="allSettingBtns(idx)" :class="['multiSwitchBtn', i.stylcss]"></div>
                <div @click="allSettingBtns(0)" :class="['multiSwitchBtn','multiSwitchBtn_module']"></div>
              </div>
            </div>
            <div :class="['curMainSetingNav',{tab_r_1:tabContent==1},{tab_r_2:tabContent==2},{tab_r_3:tabContent==3}]">
              <div @click="tabSetting(1)" class="mainSettingTab">样式设置</div>
              <div @click="tabSetting(2)" class="mainSettingTab">模块动画</div>
              <div class="triangleActive"></div>
            </div>
            <div class="closeFunPanel" @click="closeFunPane"><i class="closeFunPanelIcon"></i></div>
          </div>
          <div class="funSettingContent">
            <div v-if="tabContent==1" class="panelInnerContent panelContentScroll panelSLevelContainer panelInnerContent_addModule mCustomScrollbar _mCS_10">
              <div id="mCSB_10" class="mCustomScrollBox mCS-fk-gray mCSB_vertical mCSB_outside">
                <div id="mCSB_10_container" v-iscroll class="mCSB_container">
                  <div class="addModulePanelContent">
                    <div style="margin-top:20px; padding:0 20px;">
                      <span>网站宽度：</span>
                      <input type="radio" name="siteWidth" @click="defaultWidth()" />
                      <label>默认</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="tabContent==2" class="panelInnerContent panelContentScroll panelSLevelContainer panelInnerContent_addModule mCustomScrollbar _mCS_10">
              <div id="mCSB_10" class="mCustomScrollBox mCS-fk-gray mCSB_vertical mCSB_outside">
                <div id="mCSB_10_container" v-iscroll class="mCSB_container">
                  <div class="addModulePanelContent">
                    <div class="tit">模块动画</div>
                    <ul class="g-cf m_list">

                      <li @click="functEmt(itw)" :class="['g-fl','r'+inx,{hover:itw.cur}]" v-for="(itw,inx) in mutList"
                        :key="inx">
                        <span v-if="inx==0" class="icon_txt">无</span>
                        <span v-if="inx>0" :class="['icon','ico_r'+inx]"></span>
                        <p class="user">{{itw.name}}</p>
                        <em class="cur_icon"></em>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  let ov = {};
  import Vue from 'vue';
  import bus from '@/common/bus.js';
  import dat from '../../../static/js/sideData.js';
  // import db from '../../static/js/db.js'
  import {
    mapState,
    mapMutations,
    mapGetters,
    mapActions
  } from 'vuex';


  let mName = ['mFont', 'mImage', 'mButton', 'signUp', 'memberPassword', 'graphic', 'mNewDes', 'columnPicture',
    'mCaseDes', 'mPhotoDes', 'multiCarousel', 'circleRrea', 'areaVideo', 'articleScrap', 'productNav', 'newlyShop',
    'productShow', 'productDes', 'productSearch', 'photoMoreCard', 'areaFile', 'areaMap', 'areaIndexFavorite',
    'areaLocation', 'videoNav', 'areaMap', 'sidebar', 'moduleAreaNav', 'footerNav', 'memberLogin', 'msgSubmit',
    'siteForm', 'serviceOnline', 'siteQrCode', 'zhaopin', 'photoMoreCard', 'zhaopinDetail', 'areaFileNav',
    'mltilingual', 'areaCode', 'sitemap', 'singlePage', 'areaDate', 'areaFlv', 'friendLink', 'searchResults'
  ];

  for (let m = 0; mName.length > m; m++) {
    ov[mName[m]] = () =>
      import('../t1/m/' + mName[m] + '.vue');
  }

  function g(id) {
    return document.getElementById(id)
  };

  //禁止选中对话框内容
  if (document.attachEvent) { // ie的事件监听，拖拽div时禁止选中内容，firefox与chrome已在css中设置过-moz-user-select: none; -webkit-user-select: none;
    g('mtDialog').attachEvent('onselectstart', function() {
      return false;
    });
  }

  function autoCenter(el) {
    if (!el) {
      return;
    }
    // 获取可见窗口大小
    var bodyW = document.documentElement.clientWidth;
    var bodyH = document.documentElement.clientHeight;
    // 获取对话框宽、高
    var elW = el.offsetWidth;
    var elH = el.offsetHeight || el.clientHeight;
    // debugger
    el.style.left = (bodyW - elW) / 2 + 'px';
    el.style.top = (bodyH - elH) / 2 + 'px';
  };

  var dx = 0,
    dy = 0,
    pageW,
    pageH,
    dialogW,
    isDraging,
    dialogH;
  var mx = 0,
    my = 0; //鼠标x、y轴坐标（相对于left，top）
  export default {
    name: 'footerNav',
    components: ov,
    data() {
      return {
        msg: '左边侧栏导航',
        disDiv: 0,
        param: {
          id: this.$route.params.id,
          param: this.$route.params.param,
          company_id: this.$route.query.company_id,
          token: this.$route.query.token,
          column_id: this.$route.query.column_id,
          type: this.$route.query.type,
          version_id: this.$route.query.pc_version_id,
          itemData: {}
        },
        mItem: dat.map((obj, index) => {
          obj.order = index + 1;
          var mtIteml = obj.mtIteml;
          let ts = this;
          if (mtIteml && mtIteml.length) {
            for (var i = 0; mtIteml.length > i; i++) {
              var itemArr = mtIteml[i].itemArr;
              if (itemArr && itemArr.length) {
                for (var j = 0; itemArr.length > j; j++) {
                  if (ts.$route.path.indexOf("/t2/") != -1 || ts.$route.path.indexOf("/t3/") != -1) {
                    if (itemArr[j].tName == 'columnLayout' || itemArr[j].tName == 'photoMoreCard' || itemArr[j].tName ==
                      'areaDate' || itemArr[j].tName == 'areaIndexFavorite') {
                      itemArr[j].isShow = false;
                    }
                  } else if (ts.$route.path.indexOf("/t1/") != -1) {
                    if (itemArr[j].tName == 'footerNav') {
                      itemArr[j].isShow = false;
                    }
                  }
                  if (itemArr[j].tName == 'fullScreen') {
                    itemArr[j].isShow = false;
                  }
                }
              }
            }
          }

          return obj;
        }),
        isAll: false,
        mtEm: {},
        myModule: [],
        customize: [],
        mutList: [{
          id: 1,
          name: "无效果",
          cur: false,
          animation: ""
        }, {
          id: 2,
          name: "左入1",
          cur: false,
          animation: "animated bounceInLeft"
        }, {
          id: 3,
          name: "右入1",
          cur: false,
          animation: "animated bounceInRight"
        }, {
          id: 4,
          name: "掉下",
          cur: false,
          animation: "animated bounceInDown"
        }, {
          id: 5,
          name: "下进",
          cur: false,
          animation: "animated bounceInUp"
        }, {
          id: 6,
          name: "闪现",
          cur: false,
          animation: "animated flash"
        }, {
          id: 7,
          name: "左上入",
          cur: false,
          animation: "animated rotateInDownLeft"
        }, {
          id: 8,
          name: "右上入",
          cur: false,
          animation: "animated rotateInDownRight"
        }, {
          id: 9,
          name: "左入2",
          cur: false,
          animation: "animated slideInLeft"
        }, {
          id: 10,
          name: "右入2",
          cur: false,
          animation: "animated slideInRight"
        }, {
          id: 11,
          name: "放大",
          cur: false,
          animation: "animated bounceIn"
        }],
        isSetWidth: false,
        tabContent: 1,
        bodyWidth: '',
        tabColumnContent: 1,
        editDial: {
          editDialWidth: "950px",
          editDialHeight: "680px",
          editDialzIndex: 1000,
          setlink: false,
          isEdit: false,
          rTitle: ''
        },
        sideObj: {
          allId: "",
          tName: ""
        }
      }
    },
    created() {

      let ts = this;
      var AllSite = JSON.parse(localStorage.getItem(ts.param.id + ts.param.type + "customModule"));
      //app.db.version =1;
      //app.db.storeName1 = "myMaterial";
      app.db.get(ts.param.company_id + ts.param.type, "myMaterial", function(item) {

        if (item) {
          ts.myModule = JSON.parse(item.conect);
        }
      });
      /*素材库的收藏功能*/
      bus.$on('onAddCollect', (categorg, data) => {
        let mfalg = true;
        for (let i = 0; ts.myModule.length > i; i++) {
          if (ts.myModule[i].id == categorg.id) {
            let mt = ts.myModule[i].items;
            let flag = true;
            if (mt && mt.length) {
              for (let j = 0; mt.length > j; j++) {
                if (mt[j].id == data.id) {
                  data.config = JSON.parse(data.config);
                  mt[j].config = data.config;
                  flag = false;
                  ts.sideObj.allId = data.allId;
                  ts.sideObj.tName = data.tName;
                  break;
                }
              }
            }
            if (flag) {
              data.config = JSON.parse(data.config);
              mt.push(data);
            }
            mfalg = false;
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          }
        }
        if (mfalg) {
          categorg.items = [];
          data.config = JSON.parse(data.config);
          categorg.items.push(data);
          // let itemObj = categorg
          ts.myModule.push(categorg);
        }

        //保存到indexeDB
        app.db.save({
          id: ts.param.company_id + ts.param.type,
          conect: JSON.stringify(ts.myModule)
        }, "myMaterial", function() {
          //回调函数
          console.log("添加成功");
        });

      });
      //app.db.version = 2;
      //app.db.storeName = "customModule";
      app.db.get(ts.param.company_id + ts.param.type, "customModule", function(item) {
        // console.log(item);
        if (item) {
          ts.customize = JSON.parse(item.conect);
        }
        //debugger
      });
      /*加入自定义功能*/
      bus.$on('onCustomModule', (data) => {
        let ts = this;
        let mfalg = true;
        data.name = "自定义" + ts.customize.length;
        if (ts.customize.indexOf(data) == -1) {

          ts.customize.push(data);
        }
        //debugger
        //categorg.items = [];
        //data.config = JSON.parse(data.config);
        //保存到indexeDB
        app.db.save({
          id: ts.param.company_id + ts.param.type,
          conect: JSON.stringify(ts.customize)
        }, "customModule", function() {
          //回调函数
          console.log("添加成功");
        });

      });
      bus.$on('onSetAmit', (m, data) => {
        //var dt = this;
        let ts = this;
        ts.tabContent = 2;
        ts.mtEm = m;
        ts.state.flag = '';
        setTimeout(function() {
          ts.state.flag = 'onItem1';
        }, 10)

        var fetg = true;
        for (let i = 0; i < ts.mutList.length; i++) {
          if (ts.mutList[i].animation == m.emitStr) {
            ts.mutList[i].cur = true;
            fetg = false;

          } else {
            ts.mutList[i].cur = false;
          }
        }
        if (fetg) {
          ts.mutList[0].cur = true;
        }
        console.log(m.allId);
        //console.log(data);
      });

    },
    props: [''],
    computed: {
      ...mapGetters(["state", "getAllSite", "getDataCur"])
    },
    mounted: function() {
      // autoCenter(g('mtDialog'));
      this.defaultWidth()
    },
    methods: {
      blurDataFun() {
        var ts = this;
        bus.$emit('sideAreaFun', ts.sideObj);
      },
      manageFuncur(data, i) {
        let ts = this;
        ts.editDial.content = "";
        data.isEdit = true;
        ts.editDial.isEdit = true;
        console.log(data)
        switch (data.tName) {
          case "moduleAreaNav":
            ts.editDial.editDialWidth = "700px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '管理栏目';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "mImage":
            ts.editDial.editDialWidth = "950px";
            ts.editDial.editDialHeight = "680px";
            ts.editDial.rTitle =
              '编辑图片<span style="font-size:12px; color:white;"> (&nbsp;只能添加jpg,jpeg,gif,png, 免费版大小不超过1MB&nbsp;)</span>';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "areaCode":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑插入代码';
            ts.editDial.callBack = ts.blurDataFun;
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "areaFile":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "600px";
            ts.editDial.rTitle = '编辑文件下载';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "areaFileNav":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑文件分类';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "areaFlv":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑视频列表';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "areaLocation":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "600px";
            ts.editDial.rTitle = '编辑当前位置';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "areaMap":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "600px";
            ts.editDial.rTitle = '编辑在线地图';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "areaVideo":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑在线视频';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "articleScrap":
            ts.editDial.editDialWidth = "950px";
            ts.editDial.editDialHeight = "680px";
            ts.editDial.rTitle = '编辑新闻详情';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "circleRrea":
            ts.editDial.editDialWidth = "750px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑社区';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "columnPicture":
            ts.editDial.editDialWidth = "950px";
            ts.editDial.editDialHeight = "680px";
            ts.editDial.rTitle = '编辑列表多图';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "footerNav":
            ts.editDial.artTitle = "设置链接地址",
              ts.editDial.setlink = true;
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "friendLink":
            ts.editDial.editDialWidth = "950px";
            ts.editDial.editDialHeight = "680px";
            ts.editDial.rTitle = '编辑云链';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "graphic":
            ts.editDial.editDialWidth = "900px";
            ts.editDial.editDialHeight = "680px";
            ts.editDial.rTitle = '编辑图文列表';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "mButton":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "650px";
            ts.editDial.rTitle = '编辑按钮';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "mCaseDes":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑案例详情';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "memberLogin":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑会员登录';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "memberPassword":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑忘记密码';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "mFont":
            ts.editDial.editDialWidth = "750px";
            ts.editDial.editDialHeight = "600px";
            ts.editDial.rTitle = '编辑文本';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;

          case "mltilingual":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑多语言';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "mNewDes":
            ts.editDial.editDialWidth = "950px";
            ts.editDial.editDialHeight = "680px";
            ts.editDial.rTitle = '编辑新闻详情';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "mNewsNav":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑新闻导航';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;

          case "mPhotoDes":
            ts.editDial.editDialWidth = "950px";
            ts.editDial.editDialHeight = "680px";
            ts.editDial.rTitle = '编辑相册详情';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "msgSubmit":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑留言提交';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "multiCarousel":
            ts.editDial.editDialWidth = "950px";
            ts.editDial.editDialHeight = "680px";
            ts.editDial.rTitle = '编辑轮播图';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "newlyShop":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑在线视频';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "photoMoreCard":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '管理魔方多图';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "productDes":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑产品详情';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "productNav":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑产品导航';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "productSearch":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑产品搜索';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "productShow":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑产品列表';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "searchResults":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑全站搜索';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "serviceOnline":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "600px";
            ts.editDial.rTitle = '编辑在线客服';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "sidebar":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "600px";
            ts.editDial.rTitle = '编辑侧边栏';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "signUp":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑会员注册';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "singlePage":
            ts.editDial.editDialWidth = "950px";
            ts.editDial.editDialHeight = "680px";
            ts.editDial.rTitle = '编辑单页管理';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "siteForm":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑在线表单';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "sitemap":
            ts.editDial.editDialWidth = "700px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '管理栏目';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "siteQrCode":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "550px";
            ts.editDial.rTitle = '编辑网站二维码';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "videoNav":
            ts.editDial.editDialWidth = "650px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '编辑视频分类';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "zhaopin":
            ts.editDial.editDialWidth = "950px";
            ts.editDial.editDialHeight = "680px";
            ts.editDial.rTitle = '编辑招聘列表';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          case "zhaopinDetail":
            ts.editDial.editDialWidth = "950px";
            ts.editDial.editDialHeight = "680px";
            ts.editDial.rTitle = '编辑招聘详情';
            ts.sideObj.allId = data.allId;
            ts.sideObj.tName = data.tName;
            break;
          default:
            ts.editDial.editDialWidth = "700px";
            ts.editDial.editDialHeight = "580px";
            ts.editDial.rTitle = '管理';

        }
        bus.$emit('sideIsFuncur', data, ts.editDial);
      },
      defaultWidth() {
        let ts = this;
        if (document.body.clientWidth < 1200) {
          ts.state.width = '1200px';
        } else {
          ts.state.width = '100%'
        }

        ts.isSetWidth = false;
      },
      functEmt(ation) {
        let ts = this;
        ation.cur = true;
        for (let i = 0; ts.mutList.length > i; i++) {
          ts.mutList[i].cur = false;
        }
        ation.cur = true;
        ts.mtEm.emitStr = ation.animation;
        ts.mtEm.isShow = false;
        setTimeout(function() {
          ts.mtEm.isShow = true;
          //$('#dowebok').removeClass('bounce');
        }, 10);
        console.log("d:" + ation.animation);
      },
      tabSetting(flag) {
        this.tabContent = flag;
        //debugger;
      },
      tabColumnSetting(e) {
        this.tabColumnContent = e;
      },
      widthOne() {
        let ts = this;
        ts.state.width = '960px';
        //$('body').css('width','960px');
        ts.isSetWidth = false;
      },
      widthTwo() {
        let ts = this;
        ts.state.width = '1200px';
        //$('body').css('width','1200px');
        ts.isSetWidth = false;
      },

      onDrag(x, y) {
        let ts = this;
        ts.x = x;
        ts.y = y;
      },
      stopDownDarg(e) {
        e.stopPropagation();
      },
      devYun(arr, it, flag) {
        let ts = this;
        var j = arr.indexOf(it);

        arr.splice(j, 1);
        if (flag == "myMaterial") {
          //debugger
          app.db.save({
            id: ts.param.company_id + ts.param.type,
            conect: JSON.stringify(ts.myModule)
          }, flag, function() {
            //回调函数
            console.log("删除成功");
          });

        } else {
          app.db.save({
            id: ts.param.company_id + ts.param.type,
            conect: JSON.stringify(ts.customize)
          }, flag, function() {
            //回调函数
            console.log("删除成功");
          });
        }

        if (arr.length) {
          localStorage.setItem(ts.param.id + ts.param.type + "customModule", JSON.stringify(arr));
        } else {
          localStorage.removeItem(ts.param.id + ts.param.type + "customModule", JSON.stringify(arr));
        }
      },
      allSettingBtns(index) {
        let ts = this;
        console.log(index);
        if (index == 0 || index == 1) {
          ts.onItem(index);
        }

        //debugger
        ts.isAll = !ts.isAll;
      },
      drag: function(event, i) {
        console.log("开始拖动");
        this.dom = event.currentTarget;
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.setData("text", event.target.outerHTML);
        event.dataTransfer.setDragImage(event.target, 0, 0);
        this.setCurOrder(i);
        //console.log(this.state.curOrder );
      },
      downDarg(e) {
        console.log('downDarg')
        e.stopPropagation();
        pageW = document.documentElement.clientWidth;
        pageH = document.documentElement.clientHeight;
        dialogW = g('dialog').offsetWidth;
        dialogH = g('dialog').offsetHeight;

        mx = e.pageX; //点击时鼠标X坐标
        my = e.pageY; //点击时鼠标Y坐标
        dx = g('dialog').offsetLeft;
        dy = g('dialog').offsetTop;
        isDraging = true; //标记对话框可拖动
      },
      onItem(i) {
        let ts = this;
        console.log('onItem');
        ts.state.flag = 'onItem' + i;
        ts.tabContent = 1;
        //this.state.flag = false;
      },
      closeFunPane() {
        //this.state.flag = 5;
        this.state.flag = true;
        console.log('sideCon')
      },
      ...mapMutations([
        'setCurOrder'
      ])

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .copy {
    text-align: center;
  }

  .no_data {
    padding: 50px;
    color: #888;
    text-align: center;
  }

  .tit {
    margin-top: 20px;
    margin-left: 20px;
  }

  .m_list {
    padding-left: 12px;

    li {
      width: 90px;
      cursor: pointer;

      .icon_txt {
        width: 50px;
        height: 50px;
        line-height: 50px;
        margin: 10px auto 0;
        display: block;
      }

      height: 90px;
      margin: 20px 10px 0;
      text-align: center;
      border: 1px solid #ccc;
      position: relative;

      .icon {
        display: block;
        margin: 10px auto 0;
        width: 50px;
        height: 50px;
        background: url(/static/image/vg_bg.png) no-repeat 0 0;
      }

      /*.ico_r0 {
				background-position: -60px 0;
			}*/
      .ico_r1 {
        background-position: -60px 0;
      }

      .ico_r2 {
        background-position: -120px 0;
      }

      .ico_r3 {
        background-position: -180px 0;
      }

      .ico_r4 {
        background-position: -243px 0;
      }

      .ico_r5 {
        background-position: -302px 0;
      }

      .ico_r6 {
        background-position: -385px 0;
      }

      .ico_r7 {
        background-position: -460px 0;
      }

      .ico_r8 {
        background-position: 0 -69px;
      }

      .cur_icon {
        width: 20px;
        height: 20px;
        bottom: 0;
        right: 0;
        display: none;
        position: absolute;
        background: url(/static/image/m_cur.png) no-repeat -296px -18px;
      }

      .user {}
    }

    li:hover,
    li.hover {
      border-color: #0D83ED;

      .cur_icon {
        display: block;
      }
    }
  }

  .cons_del {
    float: right;
    color: red;
    width: 30px;
    text-align: center;
    height: 30px;
  }
  .sideConChild{
    padding: 5px 15px;
    width: 80%;
    margin-left: 30px;
    margin-bottom: 10px;
    border:solid 1px #CCCCCC;
    border-radius: 5px;
    display:flex;
    justify-content: space-between;
    align-items: center;
    line-height: 25px;
  }
  .sideConChild .edit_mode{
    display: inline-block;
    width: 22px;
    height: 22px;
    background-image: url(/static/image/bg03.png);
    background-position: -420px -185.5px;
    background-repeat: no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/components/m/sideCon.vue